import React from "react";
import { connect } from "react-redux";
import "./styles.scss";
import ListFilter from "components/atoms/listFilter/index.jsx";
import { filterStock } from "actions/stock";
import { currency } from "helpers/format";

class Filters extends React.Component {
  state = {
    kms: [],
    prices: [],
  };

  constructor(props) {
    super(props);

    const prices = [
      { label: "Hasta $5.500.000", min: 0, max: 5500000 },
      { label: "$5.500.000 a $7.000.000", min: 5500000, max: 7000000 },
      { label: "$7.000.000 a $9.500.000", min: 7000000, max: 9500000 },
      { label: "Más de $9.500.000", min: 9500000, max: Infinity },
    ];

    const kms = [
      { label: "Hasta 25.000 km", min: 0, max: 25000 },
      { label: "25.000km a 50.000 km", min: 25000, max: 50000 },
      { label: "50.000km a 75.000 km", min: 50000, max: 75000 },
      { label: "Más de 75.000 km", min: 75000, max: Infinity },
    ];

    this.state = {
      kms,
      prices,
    };
  }

  render() {
    const { kms, prices } = this.state;

    const filters = Object.keys(this.props.filters);
    const isOutlet = window.location.pathname.includes("outlet");
    const isNewVehicles = window.location.pathname.includes("usados-sin-rodar");
    let results = this.props.vehicles.length;
    if (isOutlet) {
      results = this.props.outlet.length;
    } else if (isNewVehicles) {
      results = this.props.newItems.length;
    }

    return (
      <div className="filters">
        <div className="filters__status">
          <h3>Vehículos usados</h3>
          {results > 0 && (
            <h5>
              {results} {results > 1 ? "Resultados" : "Resultado"}
            </h5>
          )}
          {results === 0 && <h5>Sin coincidencias</h5>}
          <div className="filters__tags">
            {filters.map((filter) => {
              const value = this.props.filters[filter];

              if (
                !value ||
                (typeof value === "object" && !value?.min && !value?.max)
              ) {
                return null;
              }

              let label = value;

              if (typeof value === "object") {
                const min =
                  filter === "price" ? currency(value.min) : `${value.min} km`;
                const max =
                  filter === "price" && value.max < Infinity
                    ? currency(value.max)
                    : `${value.max} km`;

                label = value.min > 0 ? `desde ${min}` : "";

                if (value.max < Infinity) {
                  label += ` hasta ${max}`;
                }
              }

              return (
                <div
                  className="filters__tag"
                  onClick={() => this.props.filter(filter, null)}
                  key={`${filter}-${label}`}
                >
                  {label}
                </div>
              );
            })}
          </div>
        </div>

        <ListFilter label="Marca" attribute="brand" />
        <ListFilter label="Stock" attribute="location" />
        <ListFilter label="Año" attribute="year" />
        <ListFilter label="Precio" attribute="price" interval values={prices} />
        <ListFilter label="Kilometraje" attribute="km" interval values={kms} />
        <ListFilter label="Combustible" attribute="engine" />
        <ListFilter label="Carrocería" attribute="body" />
        <ListFilter label="Color" attribute="color" />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    filters: state.stock.filters,
    vehicles: state.stock.items,
    outlet: state.stock.outletItems,
    newItems: state.stock.newItems,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    filter: (attribute, value) => {
      dispatch(filterStock(attribute, value));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Filters);
